import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import FilesSection from '../features/files/FilesSection';

function FilesPage(): JSX.Element {
    const { id: workpaperId, readOnly } = useWorkpaperContext();

    return (
        <>
            <section className="pb-2 px-1 flex flex-col" style={{ height: 'calc(((((100vh - 56px) - 45px) - 8px) - 32px) - 4px)' }}>
                <FilesSection title="Files" startingFolderId={workpaperId} readOnly={readOnly} workpaperId={workpaperId} />
            </section>
        </>
    );
}

export default FilesPage;
